import { QuestDifficulty } from "../client/generated/graphql";

export const timeValueToXP = (duration: number) => {
    const minutes = Math.floor(duration / 1000 / 60);
    return Math.floor(minutes / 3);
}

export const mapDifficultyToXp = (difficulty?: QuestDifficulty | null) => {
    switch(difficulty) {
        case QuestDifficulty.NoEffort: return 1;
        case QuestDifficulty.Easy: return 5;
        case QuestDifficulty.Medium: return 10;
        case QuestDifficulty.Challenging: return 20;
        case QuestDifficulty.Hardcore: return 40;
        default: return 0;
    }
}